module.exports = __webpack_public_path__ + "img/logo-giordano-immobilier.7044b686.svg";